import { render } from "./CarouselItem.vue?vue&type=template&id=23f8f137&ts=true"
import script from "./CarouselItem.vue?vue&type=script&lang=ts"
export * from "./CarouselItem.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devgeorge/andrea/webpage_curaduria2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__